import { render, staticRenderFns } from "./MyStudentDetails.vue?vue&type=template&id=00001bf1&scoped=true&"
import script from "./MyStudentDetails.vue?vue&type=script&lang=js&"
export * from "./MyStudentDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyStudentDetails.vue?vue&type=style&index=0&id=00001bf1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00001bf1",
  null
  
)

export default component.exports